import { render, staticRenderFns } from "./ParticipantContact.vue?vue&type=template&id=5aec98b6&scoped=true"
import script from "./ParticipantContact.ts?vue&type=script&lang=ts&external"
export * from "./ParticipantContact.ts?vue&type=script&lang=ts&external"
import style0 from "./ParticipantContact.scss?vue&type=style&index=0&id=5aec98b6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aec98b6",
  null
  
)

export default component.exports